export default function (Alpine) {
  function checkTextOverflow(element, size) {
    element.style.fontSize = `${size}px`;
    return element.scrollWidth > element.offsetWidth;
  }

  function findOptimalFontSize(element, containerWidth) {
    let minSize = 1;
    let maxSize = Math.min(500, containerWidth);
    const precision = 0.5;
    const MAX_ITERATIONS = 15;

    const textLength = element.textContent?.length || 0;
    let fontSize = Math.min(maxSize, Math.sqrt(containerWidth) * (15 / Math.sqrt(Math.max(1, textLength))));

    if (checkTextOverflow(element, fontSize)) {
      maxSize = fontSize;
    } else {
      minSize = fontSize;
    }

    let iterations = 0;

    while (maxSize - minSize > precision && iterations < MAX_ITERATIONS) {
      fontSize = (minSize + maxSize) / 2;

      if (checkTextOverflow(element, fontSize)) {
        maxSize = fontSize;
      } else {
        minSize = fontSize;
      }

      iterations++;
    }

    return minSize * 0.99;
  }

  if (!document.getElementById('x-jumbo-styles')) {
    const style = document.createElement('style');
    style.id = 'x-jumbo-styles';
    style.textContent = `
      [x-jumbo] { opacity: 0; transition: opacity 0.3s ease; }
      [x-jumbo].ready { opacity: 1; }
    `;
    document.head.appendChild(style);
  }

  Alpine.directive('jumbo', (el, _binding, { cleanup }) => {
    const originalStyles = {
      fontSize: el.style.fontSize,
      width: el.style.width
    };

    el.style.width = '100%';

    const calculateOptimalFontSize = () => {
      if (!el.textContent?.trim()) return;

      el.classList.remove('ready');

      const containerWidth = el.offsetWidth;
      if (containerWidth <= 0) return;

      el.style.fontSize = `${findOptimalFontSize(el, containerWidth)}px`;
      el.classList.add('ready');
    };

    requestAnimationFrame(calculateOptimalFontSize);

    const resizeObserver = new ResizeObserver(calculateOptimalFontSize);
    resizeObserver.observe(el);

    cleanup(() => {
      resizeObserver.disconnect();
      el.classList.remove('ready');
      Object.assign(el.style, originalStyles);
    });
  });
}
